var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"maxlength":"7","placeholder":"Ex:. ABC1A23","label":"Placa","outlined":"","dense":""},on:{"input":function($event){return _vm.$emit('input', _vm.item)}},model:{value:(_vm.item),callback:function ($$v) {_vm.item=$$v},expression:"item"}})
}
var staticRenderFns = []

export { render, staticRenderFns }